import React from 'react'

export default class IconsMainNavListCleaner extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M14.6667 8.66669V4.00002C14.6667 3.6464 14.5262 3.30726 14.2761 3.05721C14.0261 2.80716 13.687 2.66669 13.3333 2.66669H2.66667C2.31305 2.66669 1.97391 2.80716 1.72386 3.05721C1.47381 3.30726 1.33334 3.6464 1.33334 4.00002V12C1.33334 12.7334 1.93334 13.3334 2.66667 13.3334H8'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M14.6667 4.66669L8.68667 8.46669C8.48085 8.59564 8.24288 8.66403 8 8.66403C7.75712 8.66403 7.51916 8.59564 7.31334 8.46669L1.33334 4.66669'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10.6667 12.6666L12 14L14.6667 11.3333'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
